import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { makeStyles } from "@material-ui/core/styles";
import { capitalize } from "../../util/stringFormat";

import AddMediaToParentMenu from "./AddMediaToParentMenu";

import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import AddIcon from "@material-ui/icons/Add";

const useStyles = makeStyles(theme => ({
  menuContainer: {
    zIndex: "1000",
  },

  menu: {
    borderRadius: "5px",
    boxShadow: "0px 0px 30px rgba(149, 169, 177, 0.3)",
    width: "400px",
    overflow: "hidden",
  },

  list: {
    height: 400,
    "@media (min-height: 600px)": {
      height: 510,
    },
  },
}));

const AddMediaToParentDropDown = props => {
  const classes = useStyles();
  const {
    parent,
    disableButton,
    childList,
    showAlert,
    handleAddSuccess,
  } = props;

  const anchorRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  const toggleMenu = () => setOpenMenu(!openMenu);
  const closeMenu = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenMenu(false);
  };

  const handleMediaAdd = () => setOpenMenu(false);

  const [active, setActive] = useState(-1);
  const [menuItems, setMenuItems] = useState([]);
  const handleListKeyDown = useCallback(
    event => {
      if (event.key === "ArrowDown") {
        event.preventDefault();
        setActive(active => (active + 1 <= menuItems.length ? active + 1 : 0));
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        setActive(active => (active - 1 >= 0 ? active - 1 : menuItems.length));
      } else if (event.key === "Tab") {
        event.preventDefault();
        setOpenMenu(true);
        document.querySelector("#add-media-to-parent-button").focus();
      }
    },
    [menuItems.length],
  );

  useEffect(() => {
    const activeElement = document.querySelector(`[data-index='${active}']`);
    if (activeElement) {
      activeElement.focus();
    }
  }, [active]);

  const prevOpen = useRef(openMenu);
  useEffect(() => {
    if (prevOpen.current === true && openMenu === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = openMenu;
  }, [openMenu]);

  const convertParent = useCallback(() => {
    return capitalize(parent);
  }, [parent]);

  return (
    <Fragment>
      <Button
        ref={anchorRef}
        onClick={toggleMenu}
        startIcon={<AddIcon />}
        aria-controls={openMenu ? `add-to-${parent}-drop-down` : undefined}
        aria-haspopup="true"
        disabled={disableButton}
        style={{
          backgroundColor: openMenu && "rgba(0, 0, 0, 0.04)",
        }}
      >
        {`Add to ${convertParent()}`}
      </Button>
      <Menu
        open={openMenu}
        onClose={closeMenu}
        anchorEl={anchorRef.current}
        id={`add-to-${parent}-drop-down`}
        onKeyDown={handleListKeyDown}
        classes={{
          paper: classes.menu,
        }}
        PopoverClasses={{
          root: classes.menuContainer,
        }}
        MenuListProps={{
          classes: {
            root: classes.list,
          },
        }}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <AddMediaToParentMenu
          active={active}
          setMenuItems={setMenuItems}
          open={openMenu}
          parentType={parent}
          childList={childList}
          showAlert={showAlert}
          closeMenu={handleMediaAdd}
          handleAddSuccess={handleAddSuccess}
        />
      </Menu>
    </Fragment>
  );
};

export default AddMediaToParentDropDown;
